import styled from "styled-components";
import { colors } from "../theme/tokens";

export const MainContent = styled.div`
  flex-grow: 1;
  min-width: 0;
  overflow: auto;
  background: ${colors.bg};
`;
